import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { TABLET_BREAKPOINT } from '../../../../Helpers/constants';
import KenIcon from '../../../KenIcon';
import { useApplicationContext } from '../../../../Helpers/Contexts/applicationContext';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';

const useStyles = makeStyles((theme) => ({
  stepperRoot: {
    gap: '24px',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      overflow: 'auto',
      alignItems: 'flex-start',
      marginTop: 8,
      gap: '8px',
    },
    [theme.breakpoints.down('md')]: {
      gap: '8px',
    },
  },
  header: {
    position: 'sticky',
    zIndex: 1,
    padding: '26px',
    background: '#FFFFFF',
    borderBottom: '1px solid #E6E6E6',
  },
  stepContainer: {
    gap: '8px',
    minWidth: '204px',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      flexDirection: 'column',
      minWidth: 'auto',
    },
    [theme.breakpoints.down('md')]: {
      minWidth: 'auto',
      gap: '0px',
    },
  },
  iconContainer: {
    height: '24px',
    width: '24px',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      paddingRight: 0,
      paddingBottom: 8,
    },
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      paddingRight: 0,
      paddingBottom: 8,
    },
  },
  completedIcon: {
    background: '#604797',
    height: '24px',
    width: '24px',
    borderRadius: '30px',
  },
}));

const Connector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#784af4',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#784af4',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const StepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: theme.palette.primary.main,
  }),
  '& .QontoStepIcon-completedIcon': {
    color: '#52C15A',
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));

function StepIcon(props) {
  const { active, completed, className, stepIcon, icon } = props;
  const classes = useStyles();

  return (
    <StepIconRoot ownerState={{ completed, active }} className={className}>
      {completed ? (
        <Typography component={'h6'} className={`d-flex align-items-center justify-content-center ${classes.completedIcon}`} variant="smallmedium" color={'#fff'}>
          {icon}
        </Typography>
      ) : stepIcon ? (
        <KenIcon icon={stepIcon} />
      ) : (
        <CircleOutlinedIcon />
      )}
    </StepIconRoot>
  );
}

export default function CustomizedSteppers(props) {
  const { applicationState } = useApplicationContext();
  const { applicationData } = applicationState;
  const { steps, alternativeLabel = false, connectorProps, activeStep } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      {applicationData.application.Application_Status__c == 'Application Complete' ||
      applicationData.application.Application_Status__c == 'Under Review' ||
      applicationData.application.Application_Status__c == 'Shortlisted' ||
      applicationData.application.Application_Status__c == 'Pending License' ||
      applicationData.application.Application_Status__c == 'Withdrawn' ||
      applicationData.application.Application_Status__c == 'Declined' ||
      applicationData.application.Application_Status__c == 'License Issued' ||
      applicationData.Application_Status__c == 'Waitlisted' ? (
        <></>
      ) : (
        <Box className={classes.header}>
          {/* <Stepper classes={{ root: classes.stepperRoot }} alternativeLabel={alternativeLabel} activeStep={activeStep} connector={connectorProps?.display ? <Connector {...connectorProps} /> : <></>}>
            {steps.map((step, index) => (
              <Step key={index}>
                <StepLabel
                  className={classes.stepContainer}
                  StepIconComponent={(labelProps) => {
                    return <StepIcon {...labelProps} stepIcon={step?.icon} completedStepIcon={step.completedStepIcon} className={classes.iconContainer} />;
                  }}
                >
                  {isMobileScreen ? (
                    activeStep === index ? (
                      <Typography variant={isMobileScreen ? 'extrasmallmedium' : 'medium'} component={'h6'} color={'#333333'}>
                        {step?.stepName}
                      </Typography>
                    ) : null
                  ) : (
                    <Typography variant={isMobileScreen ? 'extrasmallmedium' : 'medium'} component={'h6'} color={'#333333'}>
                      {step?.stepName}
                    </Typography>
                  )}
                </StepLabel>
              </Step>
            ))}
          </Stepper> */}
        </Box>
      )}
    </>
  );
}
